import { useContext, useEffect, useState } from "react";
import Sidebar from "../../../shared/components/sidebar/Sidebar";
import Navbar from "../../../shared/components/navbar/Navbar";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

import { AuthContext } from "../../../shared/context/auth-context";
import "../../../shared/css/lists.scss";
import DatatableTratamentos from "../components/datatable/DatatableTratamentos";
import { ClinicaContext } from "../../../shared/context/clinica-context";
import { useHttpClient } from "../../../shared/hooks/http-hook";

function AgendamentosTratamento() {
  const [medicos, setMedicos] = useState();
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const { sendRequest } = useHttpClient();

  useEffect(() => {
    const fetchMedicos = async () => {
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/users/ativos/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        const temp = [];
        response.users.forEach((u) => {
          if (
            u.role.role === "Dentista" ||
            u.role.role === "Médico/Administrador"
          ) {
            temp.push({ ...u, nome: u.name });
          }
        });
        setMedicos(temp);
      } catch (err) {
        console.error("err", err);
      }
    };

    const fetchMedicosAssociados = async () => {
      try {
        // Buscar dados completos dos médicos associados
        const medicoIds = auth.usuariosAssociados.map((u) => u.id);

        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/users/ativos/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        // Filtrar apenas os médicos associados
        const temp = [];
        response.users.forEach((u) => {
          if (
            medicoIds.includes(u.id) &&
            (u.role.role === "Dentista" ||
              u.role.role === "Médico/Administrador")
          ) {
            temp.push({ ...u, nome: u.name });
          }
        });
        setMedicos(temp);
      } catch (err) {
        console.error("Erro ao buscar médicos associados:", err);
      }
    };

    if (auth.role === "Médico/Administrador" || auth.role === "Gerente") {
      fetchMedicos();
    } else if (auth.role === "Secretária(o)" || auth.role === "Assistente") {
      fetchMedicosAssociados();
    }
  }, [auth.token, clinica.clinica._id, sendRequest]);

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar
          title="Agendamento"
          icon={CalendarMonthOutlinedIcon}
          medicos={medicos}
        />
        <DatatableTratamentos medicos={medicos} />
      </div>
    </div>
  );
}

export default AgendamentosTratamento;
